module.exports = __webpack_public_path__ + "static/media/bigBaseImage.d549afeb.png";